import React, { useEffect, useState } from "react";
import { roleList, stuclasslist, studivisionlist } from "../../../services/master";
import { academylist, dobreportlist, repadmissionlist } from "../../../services/admin";
import Select from "react-select";
import { toast } from "react-toastify";
import { studentfilter } from "../../../services/student";
import { AgGridReact } from "ag-grid-react";
import { useLocation } from "react-router-dom";
import moment from "moment";

export default function StudentReport() {
    const [aclist, setACList] = useState([]);
    const [acaid, setAcaID] = useState("");

    const [stucls, setStuCls] = useState("");
    const [clist, setCList] = useState([]);

    const [stusec, setStuSec] = useState("");
    const [slist, setSList] = useState([]);

    const [stuid, setStuId] = useState("");
    const [stulist, setStuList] = useState([]);

    const [replist, setRepList] = useState([]);

    const [role, setRole] = useState(4);
    const [rlist, setRList] = useState([]);

    const [fromdate, setFromDate] = useState("");
    const [todate, setToDate] = useState("");
    const [gder, setGender] = useState("");

    const columnDefs = [

        {
            headerName: "Student",
            width: 150,
            field: "student_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Username",
            width: 150,
            field: "username",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },

        {
            headerName: "Academic Year",
            width: 200,
            field: "aca_year",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Class",
            width: 110,
            field: "class_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Section",
            width: 110,
            field: "section_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Mobile",
            width: 150,
            field: "phone",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "State",
            width: 120,
            field: "state_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "District",
            width: 120,
            field: "district",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "City",
            width: 120,
            field: "city",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },

    ];
    const [urllink, setUrl] = useState("");
    const location = useLocation();
    useEffect(() => {
        const path = location.pathname.split("/")[2]; // Extracts 'allstudent' or 'leftstudentlist'
        setUrl(path);
        setRepList([]);
        academylist().then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.details.length > 0) {
                    for (let i = 0; i < res.data.details.length; i++) {
                        arr.push({
                            value: res.data.details[i].id,
                            label:
                                res.data.details[i].name + " - " + res.data.details[i].code,
                        });
                    }
                    setACList(arr);
                }
            }
        });

        if (localStorage.getItem("AAcademy") != null) {
            academylist().then((res) => {
                if (res.status === true) {
                    let arr = [];
                    if (res.data.details.length > 0) {
                        for (let i = 0; i < res.data.details.length; i++) {
                            if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                                arr.push({
                                    value: res.data.details[i].id,
                                    label:
                                        res.data.details[i].name + " - " + res.data.details[i].code,
                                });
                            }
                            if (arr.length > 0) {
                                setAcaID(arr[0]);
                                if (path === "studentreport") {
                                    filterstu(arr[0],'', '', '');
                                }
                            }
                        }

                    }
                }
            });
        }

        if (path === "studentreport") {
            stuclasslist().then((res) => {
                if (res.status === true) {
                    let arr = [];
                    if (res.data.length > 0) {
                        for (let i = 0; i < res.data.length; i++) {
                            arr.push({
                                value: res.data[i].id,
                                label: res.data[i].class_name,
                            });
                        }
                    }
                    setCList(arr);
                }
            });
            studivisionlist().then((res) => {
                if (res.status === true) {
                    let arr = [];
                    if (res.data.length > 0) {
                        for (let i = 0; i < res.data.length; i++) {
                            arr.push({
                                value: res.data[i].id,
                                label: res.data[i].name,
                            });
                        }
                    }
                    setSList(arr);
                }
            });


        } else if (path === "admissionreport") {
            if (localStorage.getItem("ADate") !== '') {
                setFromDate(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
                setToDate(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
                listadm('', moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"), moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"), '', '');
            } else {
                setFromDate(moment(new Date()).format("YYYY-MM-DD"));
                setToDate(moment(new Date()).format("YYYY-MM-DD"));
                listadm('', moment(new Date()).format("YYYY-MM-DD"), moment(new Date()).format("YYYY-MM-DD"), '', '');
            }


        } else if (path === "dobreport") {
            setFromDate(moment(new Date()).format("YYYY-MM-DD"));
            setToDate(moment(new Date()).format("YYYY-MM-DD"));
            roleList().then((res) => {
                if (res.status === true) {
                    setRList(res.data);
                }
            });

            if (localStorage.getItem("AAcademy") != null) {
                academylist().then((res) => {
                    if (res.status === true) {
                        let arr = [];
                        if (res.data.details.length > 0) {
                            for (let i = 0; i < res.data.details.length; i++) {
                                if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                                    arr.push({
                                        value: res.data.details[i].id,
                                        label:
                                            res.data.details[i].name + " - " + res.data.details[i].code,
                                    });
                                }
                                if (arr.length > 0) {
                                    setAcaID(arr[0]);
                                    listdob(arr[0].value, moment(new Date()).format("YYYY-MM-DD"), moment(new Date()).format("YYYY-MM-DD"), 4);
                                }
                            }

                        }
                    }
                });
            } else {
                listdob('', moment(new Date()).format("YYYY-MM-DD"), moment(new Date()).format("YYYY-MM-DD"), 4);

            }

        }
    }, [location.pathname]);

    function handleAcademy(e) {
        setStuId('');

        if (e !== null) {
            setAcaID(e);
            if (urllink === "studentreport") {
                filterstu(e, stucls, stusec, stuid);
            } else if (urllink === "admissionreport") {
                listadm(e, fromdate, todate, gder, '');
            } else if (urllink === "dobreport") {
                listdob(e, fromdate, todate, role);
            }
        } else {
            setAcaID("");
            if (urllink === "studentreport") {
                filterstu('', stucls, stusec, stuid);
            } else if (urllink === "admissionreport") {
                listadm('', fromdate, todate, gder, '');
            } else if (urllink === "dobreport") {
                listdob('', fromdate, todate, role);
            }
        }
    }

    function handleStu(e) {
        if (e !== null) {
            setStuId(e);
            if (urllink === "studentreport") {
                filterstu(acaid, stucls, stusec, e);
            } else if (urllink === "admissionreport") {
                listadm(acaid, fromdate, todate, gder, e);
            }
        } else {
            setStuId("");
            if (urllink === "studentreport") {
                filterstu(acaid, stucls, stusec, '');
            } else if (urllink === "admissionreport") {
                listadm(acaid, fromdate, todate, gder, '');

            }
        }
    }


    function filterstu(aca, cl, se, stu) {
        setStuCls(cl);
        setStuSec(se);
        setStuList([]);
        const temp = new FormData();
        temp.append("year", '');
        temp.append("class", cl);
        temp.append("section", se);
        temp.append("student", stu ? stu.value : '');
        if (localStorage.getItem("Role") === "1" && aca !== "") {
            temp.append("academy", aca.value);
        }
        studentfilter(temp).then((res) => {
            if (res.status === true) {
                let arr = [];
                setRepList(res.data.details);
                if (res.data.details.length > 0) {
                    for (let i = 0; i < res.data.details.length; i++) {
                        arr.push({
                            value: res.data.details[i].id,
                            label:
                                res.data.details[i].username +
                                " - " +
                                res.data.details[i].student_name,
                        });
                    }
                }
                setStuList(arr);

            }
        });
    }

    function listadm(aca, from, to, gr, stu) {
        setFromDate(from);
        setToDate(to);
        setGender(gr);
        const temp = new FormData();
        temp.append("from_date", from);
        temp.append("to_date", to);
        temp.append("gender", gr);
        temp.append("student_id", stu ? stu.value : '');
        if (localStorage.getItem("Role") === "1" && aca !== "") {
            temp.append("academy_id", aca.value);
        } else if (localStorage.getItem("Role") !== "1") {
            temp.append("academy_id", localStorage.getItem("academy"));
        }
        repadmissionlist(temp).then((res) => {
            if (res.status === true) {
                setRepList(res.data.details);
                let arr = [];
                if (res.data.students.length > 0) {
                    for (let i = 0; i < res.data.students.length; i++) {
                        arr.push({
                            value: res.data.students[i].id,
                            label:
                                res.data.students[i].username +
                                " - " +
                                res.data.students[i].student_name,
                        });
                    }
                }
                setStuList(arr);
            }
        })
    }
    const [ppath, setPPath] = useState('');
    function listdob(aca, from, to, rle) {
        setFromDate(from);
        setToDate(to);
        const temp = new FormData();
        temp.append("from_date", from);
        temp.append("to_date", to);
        temp.append("role_id", rle);
        if (localStorage.getItem("Role") === "1" && aca !== "") {
            temp.append("academy_id", aca.value);
        }
        dobreportlist(temp).then((res) => {
            if (res.status === true) {
                setRepList(res.data.details)
                setPPath(res.data.path)
            }
        });
    }
    function submitrep(e) {
        e.preventDefault();
        let valid = "";
        if (localStorage.getItem("Role") === "1") {
            if (acaid === "") {
                valid = "Please Select Academy";
                toast.error(valid);
                return
            }
        }
        let stu = stuid ? stuid.value : ''
        let aca = ''
        if (localStorage.getItem("Role") === "1" && acaid !== "") {
            aca = acaid.value
        } else if (localStorage.getItem("Role") !== "1") {
            aca = localStorage.getItem("academy")
        }
        const reportUrl = localStorage.getItem("reportUrl");
        if (urllink === "admissionreport") {
            window.open(reportUrl + 'report/admissionexcel?academy_id=' + aca + '&from_date=' + fromdate + '&to_date=' + todate + '&student_id=' + stu + '&gender=' + gder, "_blank");
        } else if (urllink === "studentreport") {
            window.open(reportUrl + 'report/studentreport?academy_id=' + aca + '&student_id=' + stu + '&class_id=' + stucls + '&section_id=' + stusec + '&year_id=' + '' + '&active=' + 1, "_blank");
        } else if (urllink === "dobreport") {
            window.open(reportUrl + 'report/dobreportdetail?academy_id=' + aca + '&from_date=' + fromdate + '&to_date=' + todate + '&role_id=' + role, "_blank");
        }
    }
    function errorphoto(ev) {
        ev.target.src = require("../../../assets/images/user.png");
        ev.target.onerror = null;
    }

    function errorteacher(ev) {
        ev.target.src = require("../../../assets/images/teacher.jpg");
        ev.target.onerror = null;
    }



    const columnSDefs = [
        {
            headerName: "Photo",
            width: 100,
            field: "photo",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                if (params.value !== null) {

                    return (
                        <div className="text-center">
                            <img
                                src={ppath + params.value}
                                onError={(ev) => errorphoto(ev)}
                                style={{ height: "60px", width: "60px" }}
                            />
                        </div>
                    );
                } else {
                    return (
                        <div className="text-center">
                            <img
                                src={require("../../../assets/images/user.png")}
                                style={{ height: "60px", width: "60px" }}
                            />
                        </div>
                    );
                }

            },
        },
        {
            headerName: "Student",
            width: 150,
            field: "student_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Username",
            width: 150,
            field: "username",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Gender",
            width: 110,
            field: "gender",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Academic Year",
            width: 200,
            field: "aca_year",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Class",
            width: 110,
            field: "class_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Section",
            width: 110,
            field: "section_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Mobile",
            width: 150,
            field: "phone",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },


    ];

    const columnTDefs = [
        {
            headerName: "Photo",
            width: 100,
            field: "photo",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                if (params.value !== null) {

                    return (
                        <div className="text-center">
                            <img
                                src={ppath + params.value}
                                onError={(ev) => errorteacher(ev)}
                                style={{ height: "60px", width: "60px" }}
                            />
                        </div>
                    );
                } else {
                    return (
                        <div className="text-center">
                            <img
                                src={require("../../../assets/images/teacher.jpg")}
                                style={{ height: "60px", width: "60px" }}
                            />
                        </div>
                    );
                }

            },
        },
        {
            headerName: "Teacher",
            width: 150,
            field: "teacher_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Username",
            width: 150,
            field: "username",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Gender",
            width: 110,
            field: "gender",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },

        {
            headerName: "Class",
            width: 110,
            field: "class_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Section",
            width: 110,
            field: "section_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Mobile",
            width: 150,
            field: "phone",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Subject",
            width: 200,
            field: "subject_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
    ];


    const columnWDefs = [
        {
            headerName: "Photo",
            width: 100,
            field: "worker_photo",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                if (params.value !== null) {

                    return (
                        <div className="text-center">
                            <img
                                src={ppath + params.value}
                                onError={(ev) => errorphoto(ev)}
                                style={{ height: "60px", width: "60px" }}
                            />
                        </div>
                    );
                } else {
                    return (
                        <div className="text-center">
                            <img
                                src={require("../../../assets/images/user.png")}
                                style={{ height: "60px", width: "60px" }}
                            />
                        </div>
                    );
                }

            },
        },
        {
            headerName: "Worker",
            field: "worker_name",
            width: 200,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Username",
            field: "username",
            width: 200,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Employee ID",
            field: "employee_id",
            width: 200,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Gender",
            field: "gender",
            width: 150,

            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Mobile",
            field: "phone",
            width: 150,

            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
    ];






    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">
                    {urllink === "admissionreport" ? "Admission Report" : urllink === "dobreport" ? "DOB Report" : "Student Report"}
                </h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Reports</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        {urllink === "admissionreport" ? "Admission Report" : urllink === "dobreport" ? "DOB Report" : "Student Report"}
                    </li>
                </ol>
            </div>
            <div className="content-body">
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">
                            <h2 className="main-content-title tx-24 mg-b-5">
                                {urllink === "admissionreport" ? "Admission Report" : urllink === "dobreport" ? "DOB Report" : "Student Report"}
                            </h2>
                        </div>
                        <div className="card-body">
                            {urllink === "studentreport" &&
                                <div className="row">
                                    {localStorage.getItem("Role") === "1" && (
                                        <div className="col-xl-4 col-sm-6">
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Select Academy <span className="text-danger"> *</span>
                                                </label>
                                                <Select
                                                    className="default-select"
                                                    placeholder="Select Academy"
                                                    value={acaid}
                                                    options={aclist}
                                                    onChange={handleAcademy}
                                                    isSearchable={true}
                                                    isClearable
                                                    hidden
                                                />

                                            </div>
                                        </div>
                                    )}
                                    <div className="col-xl-4 col-sm-6">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Class
                                            </label>
                                            <select
                                                className="default-select form-control wide"

                                                onChange={(e) => {
                                                    setStuId('');
                                                    filterstu(acaid, e.target.value, stusec, stuid)
                                                }}
                                                value={stucls}
                                            >
                                                <option value="" disabled>
                                                    Select Class
                                                </option>
                                                {clist.map((item, i) => (
                                                    <option value={item.value} key={i}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>

                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-sm-6">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Section
                                            </label>
                                            <select
                                                className="default-select form-control wide"
                                                onChange={(e) => { setStuId(''); filterstu(acaid, stucls, e.target.value, '') }}
                                                value={stusec}
                                            >
                                                <option value="" disabled>
                                                    Select Section
                                                </option>
                                                {slist.map((item, i) => (
                                                    <option value={item.value} key={i}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>

                                        </div>
                                    </div>

                                    <div className="col-xl-4 col-sm-6">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Student Name
                                                <span className="text-danger"> *</span>
                                            </label>
                                            <Select
                                                className="default-select"
                                                placeholder="Select Student"
                                                value={stuid}
                                                options={stulist}
                                                onChange={handleStu}
                                                isSearchable={true}
                                                isClearable
                                                hidden
                                            />
                                        </div>
                                    </div>
                                    <div className="col-xl-8 col-sm-6">
                                        <div className="res-right mt-5">
                                            <button className="btn btn-success me-2" onClick={submitrep}>
                                                Excel Download
                                            </button>

                                        </div>
                                    </div>
                                </div>
                            }
                            {urllink === "admissionreport" &&
                                <div className="row">
                                    {localStorage.getItem("Role") === "1" && (
                                        <div className="col-xl-4 col-sm-6">
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Select Academy <span className="text-danger"> *</span>
                                                </label>
                                                <Select
                                                    className="default-select"
                                                    placeholder="Select Academy"
                                                    value={acaid}
                                                    options={aclist}
                                                    onChange={handleAcademy}
                                                    isSearchable={true}
                                                    isClearable
                                                    hidden
                                                />

                                            </div>
                                        </div>
                                    )}
                                    <div className="col-xl-4 col-sm-6">
                                        <label className="form-label">From Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={fromdate}
                                            onChange={(e) => listadm(acaid, e.target.value, todate, gder, stuid)}
                                        />
                                    </div>
                                    <div className="col-xl-4 col-sm-6">
                                        <label className="form-label">To Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={todate}
                                            onChange={(e) => listadm(acaid, fromdate, e.target.value, gder, stuid)}
                                        />
                                    </div>
                                    <div className="col-xl-4 col-sm-6">
                                        <label className="form-label">Gender</label>
                                        <select
                                            className="default-select form-control wide"
                                            value={gder}
                                            onChange={(e) => listadm(acaid, fromdate, todate, e.target.value, stuid)}
                                        >
                                            <option value="" disabled>
                                                Select Gender
                                            </option>
                                            <option value="Male">Male</option>
                                            <option value="Female">Female</option>

                                        </select>
                                    </div>
                                    <div className="col-xl-4 col-sm-6">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Student Name
                                                <span className="text-danger"> *</span>
                                            </label>
                                            <Select
                                                className="default-select"
                                                placeholder="Select Student"
                                                value={stuid}
                                                options={stulist}
                                                onChange={handleStu}
                                                isSearchable={true}
                                                isClearable
                                                hidden
                                            />
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-sm-6">
                                        <div className="res-right mt-5">
                                            <button className="btn btn-success me-2" onClick={submitrep}>
                                                Excel Download
                                            </button>

                                        </div>
                                    </div>
                                </div>}


                            {urllink === "dobreport" &&
                                <div className="row">
                                    {localStorage.getItem("Role") === "1" && (
                                        <div className="col-xl-4 col-sm-6">
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Select Academy <span className="text-danger"> *</span>
                                                </label>
                                                <Select
                                                    className="default-select"
                                                    placeholder="Select Academy"
                                                    value={acaid}
                                                    options={aclist}
                                                    onChange={handleAcademy}
                                                    isSearchable={true}
                                                    isClearable
                                                    hidden
                                                />

                                            </div>
                                        </div>
                                    )}
                                    <div className="col-xl-4 col-sm-6">
                                        <label className="form-label">From Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={fromdate}
                                            onChange={(e) => listdob(acaid, e.target.value, todate, role)}
                                        />
                                    </div>
                                    <div className="col-xl-4 col-sm-6">
                                        <label className="form-label">To Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={todate}
                                            onChange={(e) => listdob(acaid, fromdate, e.target.value, role)}
                                        />
                                    </div>
                                    <div className="col-xl-4 col-sm-6">
                                        <label className="form-label">Role</label>
                                        <select
                                            className="default-select form-control wide"
                                            value={role}
                                            onChange={(e) => { setRole(e.target.value); listdob(acaid, fromdate, todate, e.target.value) }}
                                        >
                                            <option value={0} disabled>
                                                Select Role
                                            </option>
                                            {rlist
                                                .filter(item => item.id > 3)
                                                .map((item) => {
                                                    return (
                                                        <option value={item.id} key={item.id}>
                                                            {item.name}
                                                        </option>
                                                    );
                                                })}

                                        </select>
                                    </div>
                                    <div className="col-xl-8 col-sm-6">
                                        <div className="res-right mt-5">
                                            <button className="btn btn-success me-2" onClick={submitrep}>
                                                Excel Download
                                            </button>

                                        </div>
                                    </div>
                                </div>
                            }

                            {urllink !== "dobreport" &&
                                <div className="ag-theme-alpine ag-style mt-2">
                                    <AgGridReact
                                        columnDefs={columnDefs}
                                        rowData={replist}
                                        pagination="true"
                                        paginationPageSize="10"
                                        sortingOrder={["asc", "desc"]}
                                        suppressDragLeaveHidesColumns={true}
                                    />
                                </div>
                            }
                            {urllink === "dobreport" &&
                                <div className="ag-theme-alpine ag-style mt-2">
                                    <AgGridReact
                                        columnDefs={role == 4 ? columnSDefs : role == 5 ? columnTDefs : role == 6 ? columnWDefs : columnDefs}
                                        rowData={replist}
                                        pagination="true"
                                        paginationPageSize="10"
                                        sortingOrder={["asc", "desc"]}
                                        suppressDragLeaveHidesColumns={true}
                                    />
                                </div>
                            }
                        </div>


                    </div>


                </div>
            </div>
        </div>
    );
}
